import React, { useContext } from 'react'
import { Hydrator } from '@usap/core'
import { LocalContext } from '../../../helpers/useLocalContext'
import Blog from './Blog.loadable'

const BlogLazyLoader = props => {
  const { localContext } = useContext(LocalContext)
  const { isBot } = localContext

  return (
    <Hydrator
      Component={Blog}
      lazy={!isBot}
      {...props}
    />
  )
}

export default BlogLazyLoader
